import { render, staticRenderFns } from "./StockFirmInvestmentOpinion.vue?vue&type=template&id=d7323a3e&scoped=true"
import script from "./StockFirmInvestmentOpinion.vue?vue&type=script&lang=js"
export * from "./StockFirmInvestmentOpinion.vue?vue&type=script&lang=js"
import style0 from "./StockFirmInvestmentOpinion.vue?vue&type=style&index=0&id=d7323a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7323a3e",
  null
  
)

export default component.exports